import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../Input/Button/Button';
import './PageNav.scss';

const ELLIPSIS = 'ellipsis';

export default class PageNav extends React.Component {
    /**
     * Build the list of page numbers to display without knowing the total
     * count: every page up to the current one is known to exist, plus one
     * more when the API reports a next page. Long runs of earlier pages are
     * collapsed with an ellipsis marker.
     */
    static getPageNumbers(currentPage, hasNextPage, maxVisible = 7) {
        const lastKnownPage = hasNextPage ? currentPage + 1 : currentPage;

        if (lastKnownPage <= maxVisible) {
            return Array.from({ length: lastKnownPage }, (_, i) => i + 1);
        }

        const start = Math.max(2, currentPage - 1);
        const pages = [1];

        if (start > 2) {
            pages.push(ELLIPSIS);
        }

        for (let page = start; page <= lastKnownPage; page += 1) {
            pages.push(page);
        }

        return pages;
    }

    static renderBtn(value, func) {
        if (!func) {
            return (
                <div className="page-btn d-inline-block">
                    <Button
                        disabled
                        type="wired"
                        value={value}
                        qaAttr={`${value}-btn`}
                    />
                </div>
            );
        }

        return (
            <div className="page-btn d-inline-block">
                <Button
                    type="solid"
                    value={value}
                    onClick={func}
                    qaAttr={`${value}-btn`}
                />
            </div>
        );
    }

    renderPageNumbers() {
        const { currentPage, goToPage, goToNextPage } = this.props;

        if (!currentPage || currentPage < 1 || !goToPage) {
            return null;
        }

        return PageNav.getPageNumbers(currentPage, Boolean(goToNextPage)).map(
            (page) => {
                if (page === ELLIPSIS) {
                    return (
                        <span className="page-ellipsis" key={ELLIPSIS}>
                            &hellip;
                        </span>
                    );
                }

                return (
                    <div className="page-number d-inline-block" key={page}>
                        <Button
                            type={page === currentPage ? 'solid' : 'wired'}
                            disabled={page === currentPage}
                            value={String(page)}
                            onClick={() => goToPage(page)}
                            qaAttr={`page-${page}-btn`}
                        />
                    </div>
                );
            }
        );
    }

    render() {
        const { goToPrevPage, goToNextPage } = this.props;

        return (
            <div className="component-Management-Layout-PageNav">
                {PageNav.renderBtn('Prev', goToPrevPage)}
                {this.renderPageNumbers()}
                {PageNav.renderBtn('Next', goToNextPage)}
            </div>
        );
    }
}

PageNav.propTypes = {
    /**
     * function to load previous page results
     */
    goToPrevPage: PropTypes.func,
    /**
     * function to load next page results
     */
    goToNextPage: PropTypes.func,
    /**
     * function to load a specific page of results
     */
    goToPage: PropTypes.func,
    /**
     * currently displayed page number, enables the numbered page buttons
     */
    currentPage: PropTypes.number,
};

PageNav.defaultProps = {
    goToPrevPage: null,
    goToNextPage: null,
    goToPage: null,
    currentPage: null,
};
